import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export default styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-top: 2rem;\n  padding-bottom: 1rem;\n\n  @media print {\n    padding: 1rem;\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});